<template>
  <div class="require">
    <div class="title"><img src="../../assets/require.png" /></div>
    <div>
      <div class="texttitle">参赛对象</div>
      <div class="textcon"><div class="textone">面向全市场私募基金机构管理的私募产品，不指定托管人或经纪商。</div></div>
      <div class="texttitle">符合条件</div>
      <div class="textcon">
        <div><img src="../../assets/1.png" /><span>参赛机构、参赛产品需已在中基协登记备案。</span></div>
        <div style="margin:4vw 0"><img src="../../assets/2.png" /><span>同一机构最多报名8个产品，同一组别最多报名3个产品。</span></div>
        <div><img src="../../assets/3.png" /><span>产品规模需在1000万元以上。</span></div>
      </div>
    </div>
    <singup></singup>
  </div>
</template>
<script>
import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
  .require {
    height: 100%;
    background: url("../../assets/commonbg.png") no-repeat center;
    background-size: cover;
    position: relative;
  }
  .title {
    text-align: center;
    padding-top: 10vh;
  }
  .title img {
    width: 43%;
  }
  .texttitle {
    text-align: center;
    font-size: 4.5vw;
    color: #86D4F8;
    /* background-image: -webkit-linear-gradient(#fff, #86D4F7);
    background-image: -o-linear-gradient(#fff, #86D4F7);
    background-image: -moz-linear-gradient(#fff, #86D4F7);
    background-image: linear-gradient(#fff, #86D4F7);
    -webkit-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent; */
    padding: 8vw 0 3vw 0;
    font-weight: bold;
  }
  .textcon {
    color: #fff;
    font-size: 3.5vw;
    padding: 0 6.5vw;
    line-height: 5vw;
    position: relative;
  }

  .textcon>div {
    line-height: 5.5vw;
    letter-spacing: 0.2vw;
    position: relative;
  }
  .textcon img {
    position: absolute;
    width: 7.5vw;
    margin-right: 2vw;
    top: -1vw;
    left: -2vw;
  }
  .textcon span {
    vertical-align: top;
    width: 87vw;
    padding-left: 6vw;
    box-sizing: border-box;
    display: inline-block;
    line-height: 5vw;
  }
  .textone {
    text-indent: 6vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/require.vue